import { HostFamilyBase } from "../HostFamilyBase";

export class MyChoicesController extends HostFamilyBase {

    isOnlineOrAwaiting: boolean;
    isToBeMatch: boolean;
    isRematch: boolean;
    isActiveApp: boolean;
    isPlacedOrActive: boolean;
    isPlaced: boolean;

    isApplicant: boolean;

    filters
    filtersBookmarked

    hostFamilies;
    hostFamiliesBookmarked;

    loading: boolean;
    loadingBookmarked: boolean;

    currentLikes: number;
    maxLikes: number;

    region = {
        'EAC': 'East Coast',
        'MAT': 'Mid Atlantic',
        'MIW': 'Mid West',
        'MT': 'Mountains',
        'NWG': 'New England',
        'NYM': 'NYC Metro Area',
        'SOU': 'South',
        'SOW': 'South West',
        'WEC': 'West Coast'
    }

    static override $inject = ['$scope', '$sce', '$uibModal', '$state', 'dialogs', 'applicationId', 'HostFamiliesResult', 'InterestedHostFamiliesDetails', 'applicationObservable', 'Auth', 'Activity']
    constructor($scope: angular.IScope, $sce, $uibModal, $state, private dialogs, applicationId, public HostFamiliesResult, InterestedHostFamiliesDetails, applicationObservable, private Auth, Activity) {
        super($uibModal, InterestedHostFamiliesDetails, $state, applicationId)
        this.isApplicant = Auth.user.isApplicant;

        applicationObservable.subscribe(applicationInstance => {
            this.isToBeMatch = (applicationInstance.status === 'TBM');
            this.isRematch = (applicationInstance.status === 'REM');
            this.isActiveApp = (applicationInstance.status === 'ACT');
            this.isPlaced = (applicationInstance.status === 'PLC');
            this.isOnlineOrAwaiting = (applicationInstance.status === 'OLA' || applicationInstance.status === 'AWA');
            this.isPlacedOrActive = (applicationInstance.status === 'PLC' || applicationInstance.status === 'ACT');
        })

        this.filters = {
            type: 'myChoices',
            applicationId: applicationId,
            pageNumber: 0,
            pageSize: 100,

            //fromAge: 0,
            //toAge: 6,
            //minChild: 1,
            //maxChild: 5,
            //region: {}
        };

        this.filtersBookmarked = {
            type: 'bookmark',
            applicationId: applicationId,
            pageNumber: 0,
            pageSize: 100,

            //fromAge: 0,
            //toAge: 6,
            //minChild: 1,
            //maxChild: 5,
            //region: {}
        }

        this.refreshResult();
        this.refreshResultBookmarks();

        if (Auth.user.isApplicant) {
            Activity.trackHFActivity({ applicationId: applicationId }, { type: 'APViewedMyChoicesPage' });
        }
    }

    addRecord(dataset, newElements) {
        let lastChunk = dataset[dataset.length - 1];

        let i = 0
        if (lastChunk && lastChunk.length == 1) {
            lastChunk.push(newElements[i]);
            i++;
        }

        for (; i < newElements.length; i += 2) {
            dataset.push(newElements.slice(i, i + 2));
        }
    }

    refreshResult() {
        this.loading = true;

        this.filters.pageNumber = 0;

        this.hostFamilies = [];
        this.HostFamiliesResult.query(this.filters)
            .$promise
            .then((data) => {
                this.addRecord(this.hostFamilies, data.result);
                this.currentLikes = data.currentLikes;
                this.maxLikes = data.maxLikes;
            })
            .finally(() => {
                this.loading = false;
            });
    }

    refreshResultBookmarks() {
        this.loadingBookmarked = true;

        this.filtersBookmarked.pageNumber = 0;

        this.hostFamiliesBookmarked = [];
        this.HostFamiliesResult.query(this.filtersBookmarked)
            .$promise
            .then((data) => {
                this.addRecord(this.hostFamiliesBookmarked, data.result);
                this.currentLikes = data.currentLikes;
                this.maxLikes = data.maxLikes;
            })
            .finally(() => {
                this.loadingBookmarked = false;
            });
    }

    hostFamiliesState() {
        return this.isApplicant ? "app.hostFamilies.interestedFamilies" : "app.applications.hostFamilies.interestedFamilies";
    }

    interested(hf) {
        this.openFeedbackDialog(hf, true)
            .result
            .then(() => {
                hf.interested = true;

                this.currentLikes++;
                this.InterestedHostFamiliesDetails.limits({ applicationId: this.applicationId })
                    .$promise
                    .then((limits) => {
                        this.currentLikes = limits.currentLikes;
                        this.maxLikes = limits.maxLikes;
                    })
            });
    }

    notInterested(hf) {
        this.openFeedbackDialog(hf, false)
            .result
            .then(() => {
                hf.interested = false;
            });
    }

    bookmarkToggle(hf) {
        this.HostFamiliesResult.bookmark({
            applicationId: this.applicationId,
            hostFamilyId: hf.hostFamilyId,
            bookmark: !hf.bookmark
        }, () => {
            hf.bookmark = !hf.bookmark
        })
    }

    dismiss(hf) {
        this.HostFamiliesResult.dismiss({
            applicationId: this.applicationId,
            hostFamilyId: hf.hostFamilyId,
            requestId: hf.requestId,
            proposalId: hf.proposalId 
        }, () => {
            this.refreshResult();
        })
    }
}

angular
    .module('app')
    .controller('MyChoicesController', MyChoicesController)
